module.exports = __webpack_public_path__ + "static/img/LimitedOfferLockedIn.60a2261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LimitedOfferLockedIn.png
// module id = WDIS
// module chunks = 1